import 'swiper/css'

import { Expandable } from './Expandable.js'

import { trapFocus } from "./trapFocus.js"

export class Megamenu {
    
    constructor(params) {
        this.params = params

        this.$el = typeof params.container === 'string' ? document.body.querySelector(params.container) : params.container
        this.$burgerBtn = typeof params.burger.button === 'string' ? document.body.querySelector(params.burger.button) : params.burger.button
        this.$burgerTarget = typeof params.burger.target === 'string' ? document.body.querySelector(params.burger.target) : params.burger.target
        
        this.desktopDisplayQuery = window.matchMedia(params.desktopBreakpoint) // while the media query is true, menu is displayed as mobile
        
        
        
        if (this.$el) this.init()
    }
    initBurger() {
        this.menuExpandable = new Expandable(this.$burgerTarget, {
            debug: false,
            hasPopup: 'menu',
            on: {
                open: ($menu) => {
                    // console.log('[mainmenu] open!')
                    this.$el.dataset.burgerState = 'open'
                    
                    
                    if (!this.desktopDisplayQuery.matches) {
                        // manage document overflow on mobile
                        document.documentElement.classList.add('mainmenu--open')
                        // this.mainmenuTrapFocus = trapFocus(this.$el, [this.$el.querySelector('.mainmenu__logo-link'), this.$el.querySelector('.mainmenu__search-btn'), this.$el.querySelector('#burger-btn')]) // TODO: not working
                    }
                },
                close: ($menu) => {
                    // console.log('[mainmenu] close!')
                    this.$el.dataset.burgerState = 'closed'
                    if (!this.desktopDisplayQuery.matches) {
                        document.documentElement.classList.remove('mainmenu--open')
                    }
                    // const expandedSubmenus = [ ...this.$el.querySelectorAll('[data-submenu-region][data-expanded="true"]') ]
                    // expandedSubmenu.forEach(_region => _region.expandable.close())
                    // in fact I think there is only one expandedSubmenu at a time
                    const expandedSubmenu = this.$el.querySelector('[data-submenu-region][data-expanded="true"]')
                    expandedSubmenu?.expandable.close()
                    
                    if (!this.desktopDisplayQuery.matches) {
                        // this.mainmenuTrapFocus = this.mainmenuTrapFocus?.destroy()
                    }
                }
            }
        }) 
        this.extraExpandable = new Expandable(this.$el.querySelector('#extra'), {
            hasPopup: 'menu',
        })
    }
    initRegions() {
        const allSubmenuRegions = this.$el.querySelectorAll(this.params.expandableRegionsSelector)
        allSubmenuRegions.forEach($region => new Expandable($region))
        
        // manage document overflow on desktop
        const depth1Regions = this.$el.querySelectorAll(`${this.params.expandableRegionsSelector}.depth--1`)
        depth1Regions.forEach($region => {
            $region.expandable.onOpen = (initiator) => {
                if (this.desktopDisplayQuery.matches) document.documentElement.classList.add('mainmenu--open')
            }
            $region.expandable.onClose = (initiator) => {
                if (this.desktopDisplayQuery.matches) document.documentElement.classList.remove('mainmenu--open')
            }
        })
        
    }
    initSearch() {
        new Expandable(this.$searchRegion)
    }
    initA11y() {
        const $fontsizeWidget = this.$el.querySelector('.a11y-menu__fontsize-widget')
        new Expandable($fontsizeWidget)
        
        $fontsizeWidget.addEventListener('click', (e) => {
            const value = e.target.dataset.value
            if (!value) return
            
            
            this.setFontsize(value)
        }, {capture: false, once: false, passive: false} || false)
        
        // startup
        const startVal = this.getFontsize()
        $fontsizeWidget.querySelector(`input[name="oce-fontsize"][data-value="${startVal}"]`).checked = 'checked'
        this.setFontsize(startVal)
    }
    setFontsize(value) {
        if (value === 'default') {
            document.documentElement.style.fontSize = 'initial'
        } else { 
            // strengthen
            document.documentElement.style.fontSize = '20px'
        }
        this.storeFontsize(value)
    }
    storeFontsize(value) {
        sessionStorage.setItem('a11yFontsize', value)
    }
    
    getFontsize() {
        const value = sessionStorage.getItem('a11yFontsize')
        return value ? value : 'default'
    }
    init() {
        if (this.$burgerBtn && this.$burgerTarget) this.initBurger()

        if (this.params.expandableRegionsSelector) this.initRegions()
        
        this.$searchRegion = this.$el.querySelector('.mainmenu__search-region')
        if (this.$searchRegion) this.initSearch()

        this.initA11y()
        
        this.setListeners()
        this.onDesktopDisplayQueryChange(this.desktopDisplayQuery)
    }
    setListeners() {
        this.desktopDisplayQuery.addEventListener('change', this.onDesktopDisplayQueryChange.bind(this), {capture: false, passive: true, once: false} || false)
        
        
        // this.$el.addEventListener('mouseover', () => {
        //     if (this.$el.dataset.isTransparent !== 'true' ) return
        //     if (document.querySelector('html').classList.contains('mainmenu--open') ) return
        //     const $logo = this.$el.querySelector('.mainmenu__logo')
        //     $logo.src = $logo.dataset.logoUrl
        // }, {capture: false, passive: true, once: false} ||false)
        // this.$el.addEventListener('mouseleave', () => {
        //     if (this.$el.dataset.isTransparent !== 'true') return
        //     if (document.querySelector('html').classList.contains('mainmenu--open') ) return
        //     const $logo = this.$el.querySelector('.mainmenu__logo')
        //     $logo.src = $logo.dataset.logoWhiteUrl
        // }, {capture: false, passive: true, once: false} ||false)
        
        // force closure of the expanded mainmenu when click on a `<a>` with `href="#id-of-an-element"`
        const localLinks = this.$el.querySelectorAll('.mainmenu__li--parent a[href^="#"]')
        localLinks.forEach(_$a => {
            _$a.addEventListener('click', () => {
                const expandedSubmenu = this.$el.querySelector('[data-submenu-region][data-expanded="true"]')
                expandedSubmenu?.expandable.close()
                if (this.desktopDisplayQuery.matches === false) {
                    this.menuExpandable.close() // TODO: maybe prevent the closing if a submenu region is open
                    this.extraExpandable.close()
                } 
            })
        })
    }
    onDesktopDisplayQueryChange(e) {
        if (e.matches === false) {
            this.$el.dataset.mode = 'mobile'
            this.menuExpandable.close() // TODO: maybe prevent the closing if a submenu region is open
            this.extraExpandable.close()
        } else { 
            document.documentElement.classList.remove('mainmenu--open') // handle case where burger is open on mobile, then viewport width changes
            this.$el.dataset.mode = 'desktop'
            this.menuExpandable.open()
            this.extraExpandable.open()
        }
    }
}




// TODO: clean up this Quick&Dirty mess
/* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
var prevScrollpos = window.pageYOffset

window.addEventListener('scroll', () => {
  var currentScrollPos = window.pageYOffset
  const $navigationContainer = document.body.querySelector('.navigation-container')
  if (!$navigationContainer) return
  
  if (document.body.dataset.mode === 'mobile' 
   && $navigationContainer.dataset.burgerState === 'open') {
    //   console.log('mobile+open=visible')
      $navigationContainer.classList.replace('hidden', 'visible')
  } else {
      if (prevScrollpos < currentScrollPos) {
        //   console.log('going down=hidden')
          $navigationContainer.classList.replace('visible', 'hidden')
      } else {
        //   console.log('going up=visible')
          $navigationContainer.classList.replace('hidden', 'visible')
      }
      
      prevScrollpos = currentScrollPos
  }
  
}, {capture: false, passive: true, once: false} || false)